import fetch from '../../../utils/fetch';
import {
    OFFER_LIST_RESET,
    OFFER_LIST_VIEW,
    OFFER_LIST_SUCCESS,
    TRANSACTION_LIST,
} from './mutation-types';
import {OFFERS, TRANSACTIONS} from '../../../constants/api-routes';
import {HYDRA_MEMBER, HYDRA_VIEW} from '../../../constants/hydra';

const getDefaultState = () => {
    return {
        items: [],
        view: [],
        transactionList: [],
    };
};
const state = getDefaultState();

function success(items) {
    return {type: OFFER_LIST_SUCCESS, items};
}

function view(items) {
    return {type: OFFER_LIST_VIEW, items};
}

function reset() {
    return {type: OFFER_LIST_RESET};
}

function transactionList(items) {
    return {type: TRANSACTION_LIST, items}
}

const getters = {
    items: state => state.items,
    transactionList: state => state.transactionList,
    view: state => state.view,
};

const actions = {
    getPaidItems({commit}, page = OFFERS) {
        fetch(page)
            .then(data => {
                commit(success(data[HYDRA_MEMBER]));
                commit(view(data[HYDRA_VIEW]));
            });
    },
    getTransactionList({commit}) {
        fetch(TRANSACTIONS).then((data) => {
            commit(transactionList(data[HYDRA_MEMBER]));
        })
    },
    reset({commit}) {
        commit(reset())
    },
};

const mutations = {
    [OFFER_LIST_VIEW](state, payload) {
        state.view = payload.items;
    },
    [OFFER_LIST_SUCCESS](state, payload) {
        state.items = payload.items;
    },
    [OFFER_LIST_RESET](state) {
        Object.assign(state, getDefaultState());
    },
    [TRANSACTION_LIST](state, payload) {
        state.transactionList = payload.items;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/offer/list.js